<script>

import AddonAttributes from "./AddonAttributes.vue"

export default {
    components: {AddonAttributes},
    props: ['app', 'addon'],
    data: function () {
        return {
            qtyOnStep: 1,
            selectedAddonId: null,
            currentQty: 0
        }
    },
    mounted() {
        if (this.addon.defquantity) {
            this.qtyOnStep = this.addon.defquantity
        }
    },
    methods: {
        updateQty: function (action) {
            if (!this.app.basket.products[this.addon.id]) {
                let product = {
                    id: this.addon.id,
                    price: this.app.products[this.addon.id].price,
                }
                this.app.addToBasket(product, 0)
                this.selectedAddonId = this.addon.id
            }

            this.currentQty = this.app.updateBasketQty(this.addon.id, action, this.qtyOnStep, this.addon.maxquantity)

        },
    }
}
</script>

<template>
    <div class="product_item">
        <div class="product_name">{{ trans(this.addon.name) }}</div>
        <div class="adding-box">
            <div class="prod_price">{{ this.app.products[this.addon.id].price }}, -</div>
            <div  v-if="!this.app.basket.products[this.addon.id] || this.app.basket.products[this.addon.id].qty==0" class="add_button btn primary" @click="this.updateQty('plus')"><span>{{ trans("Tilføj") }}</span></div>
            <div v-else class="product_count">
                <div class="input_holder">
                    <span class="minus btn-minus" href="javascript:void(0)" @click="this.updateQty('minus')"><i class="icon-minus"></i></span>
                    <input class="counter" :readonly="true" v-model="this.app.basket.products[this.addon.id].qty">
                    <span class="plus btn-plus" href="javascript:void(0)" @click="this.updateQty('plus')"><i class="icon-plus"></i></span>
                </div>
            </div>
        </div>
    </div>
    <div class="container sm">
        <AddonAttributes :app="this.app" :attributes="this.app.products[this.addon.id].attributes" :selectedProdId="this.selectedAddonId" :currentQty="this.currentQty" />
    </div>
</template>

<style scoped>

.product_item{
    display: flex;
    font-family: sans-serif;
    font-size: 16px;
    justify-content: space-between;
    color: #000;
    background-color: #fff;
    padding: 10px;
    align-items: center;
}
.product_item div {
    display: flex;
}
.product_name {
    font-weight: 600;
}
.prod_price {
    margin-right: 10px;
}
.adding-box{
    align-items: center;
}
.add_button {
    margin-bottom: 0;
    min-width: 70px;
    padding-top: 6px;
    padding-bottom: 6px;
    font-size: 12px;
}
.add_button:hover {
    cursor: pointer;
}
.product_count{
    color: #000;
    border: 1px solid #000;
}
.input_holder{
    position: relative;
}
.minus{
    font-size: 2px;
    text-decoration: none;
    color: #000;
    width: 20px;
    padding: 12px 10px;
}
.plus{
    font-size: 8px;
    text-decoration: none;
    color: #000;
    width: 20px;
    padding: 8px 4px;
}
.counter{
    border: 0px;
    width: 28px;
    text-align: center;
    font-size: 12px;
    color: #000;
}

</style>
